import React from 'react'
import ExtrutionGraphSection from './extrutionGraphSection';
import InjectionMouldingGraphSection from "./injectionMouldingGraphSection"
import PunchPressGraphSection from './punchPressGraphSection';
import CNCGraphSection from './cncGraphSection';
const GraphSection = ({ selectedTemplate,
  onChangeParams,
  filter,
  setLoading }) => {
  const { templateType } = filter;
  switch (templateType) {
    case 1:
      return <InjectionMouldingGraphSection filter={filter}
        setLoading={setLoading}
        selectedTemplate={selectedTemplate}
        onChangeParams={onChangeParams}
        />
    case 2:
      return <ExtrutionGraphSection
        filter={filter}
        setLoading={setLoading}
        selectedTemplate={selectedTemplate}
        onChangeParams={onChangeParams}
         />
    case 3:
      return <PunchPressGraphSection
        filter={filter}
        setLoading={setLoading}
        selectedTemplate={selectedTemplate}
        onChangeParams={onChangeParams}
        />
    case 4:
      return <CNCGraphSection 
       filter={filter}
        setLoading={setLoading}
        selectedTemplate={selectedTemplate}
        onChangeParams={onChangeParams}
        />
  }
}

export default GraphSection